import React, { useEffect } from 'react';
import Footer from './Footer';
import { motion } from 'framer-motion';

function ProductPage() {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen">
      {/* How it works section */}
      <div className="w-screen relative pt-32 md:pt-40">
        <div className="max-w-full sm:max-w-[90%] xl:max-w-[70rem] mx-auto px-4 sm:px-6 xl:px-6 pb-20 md:pb-80 mb-0 relative">
          <div className="sm:mx-0 xl:mx-[-10rem]">
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-100px" }}
            >
              <h2 className="text-[#7785FC] text-[1.125rem] md:text-[1.5rem] font-bold leading-normal md:text-center text-left font-['Edu_TAS_Beginner'] pl-1 mb-2 md:mb-0">
                GANZ EINFACH
              </h2>
              <h3 className="text-[#343434] text-[2.125rem] md:text-[4.5rem] leading-[110%] tracking-[-0.06375rem] md:tracking-[-0.135rem] mb-8 md:mb-16 md:text-center text-left font-freeman pb-4 md:pb-24">
                So erstellst du deine<br />
                besondere Hörgeschichte
              </h3>
            </motion.div>

            {/* Steps section */}
            <motion.div 
              className="space-y-12 md:space-y-24"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-100px" }}
            >
              {/* Step 1 */}
              <motion.div className="flex flex-col md:flex-row md:items-center md:gap-16 md:justify-center">
                <div className="w-full aspect-[4/3] h-[120px] md:h-auto md:w-1/3 md:aspect-[5/4] rounded-2xl overflow-hidden order-1 md:order-2">
                  <img 
                    src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/1-HBvYe43ZROhEpc369LGptgikpZtJko.png"
                    alt="Speech bubble containing question mark"
                    className="w-auto h-full object-contain md:object-center object-left scale-100 md:scale-75"
                  />
                </div>
                <div className="md:w-1/2 order-2 md:order-1">
                  <div className="mt-6 md:mt-0 text-left max-w-[95%] md:max-w-[95%] xl:max-w-[85%]">
                    <div>
                      <h4 className="font-freeman text-[1.5rem] md:text-[2.5rem] lg:text-[3.5rem] font-normal leading-[110%] tracking-[-0.045rem] md:tracking-[-0.105rem] text-[#343434] mb-2 md:mb-4">Nur ein paar Infos von dir und los geht's!</h4>
                      <p className="font-aleo text-[1.125rem] lg:text-[1.25rem] font-normal leading-[160%] text-[#343434]">
                        Beantworte ein paar einfache Fragen:<br />Hat dein Kind ein Lieblingstier, Spielzeug oder bestimmte Vorlieben? Wer wird Held*in der Geschichte?
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>

              {/* Step 2 */}
              <motion.div className="flex flex-col md:flex-row md:items-center md:gap-16 md:justify-center">
                <div className="w-full aspect-[4/3] h-[120px] md:h-auto md:w-1/3 md:aspect-[5/4] rounded-2xl overflow-hidden order-1 md:order-2">
                  <img 
                    src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/2-1bwb79z0QVvKonS50hNrurfFohBdpN.png"
                    alt="Illustration of a blue magic wand"
                    className="w-auto h-full object-contain md:object-center object-left scale-100 md:scale-75"
                  />
                </div>
                <div className="md:w-1/2 order-2 md:order-1">
                  <div className="mt-6 md:mt-0 text-left max-w-[95%] md:max-w-[95%] xl:max-w-[85%]">
                    <div>
                      <h4 className="font-freeman text-[1.5rem] md:text-[2.5rem] lg:text-[3.5rem] font-normal leading-[110%] tracking-[-0.045rem] md:tracking-[-0.105rem] text-[#343434] mb-2 md:mb-4">Magische Geschichten entstehen</h4>
                      <p className="font-aleo text-[1.125rem] lg:text-[1.25rem] font-normal leading-[160%] text-[#343434]">
                        Wir erstellen daraus in ein paar Minuten eine spannende Geschichte, die nicht nur großartig klingt, sondern auch perfekt zu deinem Kind passt.
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>

              {/* Step 3 */}
              <motion.div className="flex flex-col md:flex-row md:items-center md:gap-16 md:justify-center pb-12 md:pb-0">
                <div className="w-full aspect-[4/3] h-[120px] md:h-auto md:w-1/3 md:aspect-[5/4] rounded-2xl overflow-hidden order-1 md:order-2">
                  <img 
                    src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/3-iryqAPpyWTvZVh8jMtkdaCBK1tCs95.png"
                    alt="Illustration of a blue speaker"
                    className="w-auto h-full object-contain md:object-center object-left scale-100 md:scale-75"
                  />
                </div>
                <div className="md:w-1/2 order-2 md:order-1">
                  <div className="mt-6 md:mt-0 text-left max-w-[95%] md:max-w-[95%] xl:max-w-[85%]">
                    <div>
                      <h4 className="font-freeman text-[1.5rem] md:text-[2.5rem] lg:text-[3.5rem] font-normal leading-[110%] tracking-[-0.045rem] md:tracking-[-0.105rem] text-[#343434] mb-2 md:mb-4">Gemeinsam hören, genießen und Spaß haben</h4>
                      <p className="font-aleo text-[1.125rem] lg:text-[1.25rem] font-normal leading-[160%] text-[#343434]">
                        Fertig! Du lädst die Geschichte herunter und spielst sie dann entweder über deinen Lautsprecher oder bringst sie auf deinen Kreativ-Tonie.
                      </p>
                    </div>
                  </div>
                </div>
              </motion.div>
            </motion.div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default ProductPage; 